// extracted by mini-css-extract-plugin
export var container = "_b2-0";
export var icon = "_b2-1";
export var text = "_b2-2";